import React, { useState, useEffect } from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/common/SEO';
import StoreCard from '../components/store/StoreCard';
import { Search, Store, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StoresPage = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');

  const filteredStores = stores.filter(s =>
    (s.name || '').toLowerCase().includes(query.toLowerCase()) ||
    (s.location || '').toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    fetch(`${API_URL}/api/stores`)
      .then(r => r.json())
      .then(d => setStores(Array.isArray(d) ? d : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout title="Stores">
      <SEO title="Stores" description="Browse all stores on Minted. Shop from verified sellers." />
      <div className="px-4 py-4" data-testid="stores-page">
        <div className="flex items-center gap-2 mb-3">
          <Store className="w-5 h-5 text-emerald-700" />
          <h2 className="font-bold text-lg text-gray-900">All Stores</h2>
          {!loading && <span className="text-sm text-gray-500" data-testid="stores-count">({filteredStores.length})</span>}
        </div>
        <div className="relative mb-4">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search stores by name or location..."
            className="pl-9 h-11 rounded-xl border-stone-200 focus-visible:ring-emerald-700"
            data-testid="store-search-input"
          />
        </div>
        {loading ? (
          <div className="flex justify-center py-16">
            <Loader2 className="w-8 h-8 text-emerald-800 animate-spin" />
          </div>
        ) : filteredStores.length > 0 ? (
          <div className="grid grid-cols-1 gap-3">
            {filteredStores.map((store) => (
              <StoreCard key={store.id} store={store} />
            ))}
          </div>
        ) : stores.length > 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="store-search-empty">
            <Search className="w-12 h-12 text-gray-300 mb-3" />
            <h3 className="font-semibold text-gray-900 mb-1">No stores match "{query}"</h3>
            <p className="text-gray-500 text-sm">Try a different name or location.</p>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <Store className="w-16 h-16 text-gray-300 mb-4" />
            <h3 className="font-semibold text-gray-900 mb-2">No stores yet</h3>
            <p className="text-gray-500 text-sm">Stores will appear here when sellers set up their shop.</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default StoresPage;
